import api from "./index"

export async function getAppointments({
  offset = 0,
  limit = 10,
  search = "",
  appointment_status = null,
  start_date = null,
  end_date = null,
  patient_id = null,
} = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      offset,
      limit,
      search,
      ...(appointment_status && { appointment_status }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(patient_id && { patient_id }),
    },
  }
  return api.get("/v1/appointments", config)
}

export async function getAppointmentById(id) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.get(`/v1/appointments/${id}`, config)
}

export async function deleteAppointment(id) {
  return api.delete(`/v1/appointments/${id}`)
}

export async function updateAppointmentStatus(id, status) {
  const formData = new FormData()
  formData.append("appointment_status", status)

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }

  return api.put(`/v1/appointments/${id}`, formData, config)
}

export async function updateAppointment(id, data) {
  const formData = new FormData()

  // Only append fields that are provided
  if (data.doctor_id) formData.append("doctor_id", data.doctor_id)
  if (data.symptoms) formData.append("symptoms", data.symptoms)
  if (data.reason) formData.append("reason", data.reason)
  if (data.addition_notes)
    formData.append("addition_notes", data.addition_notes)
  if (data.appointment_date)
    formData.append(
      "appointment_date",
      new Date(data.appointment_date).toISOString()
    )
  if (data.appointment_status)
    formData.append("appointment_status", data.appointment_status)
  if (data.media_file) formData.append("media_file", data.media_file)

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }

  return api.put(`/v1/appointments/${id}`, formData, config)
}

export async function completeAppointment(id, formData) {
  // Make sure we pass the content type header correctly for multipart/form-data
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      // Remove any existing Content-Type headers that might interfere
      common: {
        "Content-Type": undefined,
      },
    },
  }

  // Ensure appointment status is added to formData
  formData.append("appointment_status", "COMPLETED")

  return api.put(`/v1/appointments/${id}`, formData, config)
}

export async function getAppointmentsStatus(patientId) {
  const config = {
    params: {
      patient_id: patientId,
    },
  }
  return api.get("/v1/appointments:getStatus", config)
}

export async function updateAppointmentWithFile(id, status, file = null) {
  const formData = new FormData()
  formData.append("appointment_status", status)
  if (file) {
    formData.append("media_file", file)
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }

  return api.put(`/v1/appointments/${id}`, formData, config)
}

export async function createAppointment(data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.post("/v1/appointments", data, config)
}
